<template>
  <div class="mb-3">
    <label class="d-block">{{ $tc("custom_forms.types.commands") }}</label>
    <v-select
      :options="options"
      v-model="commandSelected"
      :placeholder="$t('custom_forms.types.commands')"
      class="w-100"
      @input="onInputChange"
      label="name"
    />
  </div>
</template>

<script>
import {onMounted, ref, computed} from '@vue/composition-api';
import vSelect from "vue-select";
import store from "@/store";
import axios from "@axios";

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      default: () => ({data: []}),
    },
    config: Object,
  },
  setup(props, {emit}) {
    const options = ref([]);
    const commandSelected = ref();

    const fetchData = async () => {
      const {data} = await axios.get('/v1/form-actions');

      options.value = data.data.map(c => ({
        id: c.value,
        name: c.label,
      }));
    }

    onMounted(async () => {
      commandSelected.value = props.data?.data?.[0] || null
      await fetchData();
    });

    function onInputChange() {
      emit("update:data", {
        data: [commandSelected.value]
      });
    }

    return {
      options,
      commandSelected,
      onInputChange,
    };
  },
};
</script>
